import { render, staticRenderFns } from "./ResearchSearch.vue?vue&type=template&id=6f1eb178"
import script from "./ResearchSearch.vue?vue&type=script&lang=js"
export * from "./ResearchSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Projects\\MDA\\schoolofmusic-ucla\\web\\app\\themes\\ucla\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f1eb178')) {
      api.createRecord('6f1eb178', component.options)
    } else {
      api.reload('6f1eb178', component.options)
    }
    module.hot.accept("./ResearchSearch.vue?vue&type=template&id=6f1eb178", function () {
      api.rerender('6f1eb178', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/components/ResearchSearch.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/components/ResearchSearch.vue
// module id = 418
// module chunks = 0